module.exports = __webpack_public_path__ + "img/banner16.e7db598e.jpg";